module.exports = __webpack_public_path__ + "img/event_icon_selected_mobile.156ed06d.svg";